/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUserRoleRelationsQuery
 */
export interface GetUserRoleRelationsQuery {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserRoleRelationsQuery
     */
    userIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserRoleRelationsQuery
     */
    roleId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserRoleRelationsQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserRoleRelationsQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserRoleRelationsQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserRoleRelationsQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof GetUserRoleRelationsQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetUserRoleRelationsQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof GetUserRoleRelationsQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function GetUserRoleRelationsQueryFromJSON(json: any): GetUserRoleRelationsQuery {
    return GetUserRoleRelationsQueryFromJSONTyped(json, false);
}

export function GetUserRoleRelationsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserRoleRelationsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIds': !exists(json, 'userIds') ? undefined : json['userIds'],
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function GetUserRoleRelationsQueryToJSON(value?: GetUserRoleRelationsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userIds': value.userIds,
        'roleId': value.roleId,
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


